export const entityStatusConstants = {
  ENTITY_STATUS_LIST_REQUEST: 'ENTITY_STATUS_LIST_REQUEST',
  ENTITY_STATUS_LIST_SUCCESS: 'ENTITY_STATUS_LIST_SUCCESS',
  ENTITY_STATUS_LIST_FAILURE: 'ENTITY_STATUS_LIST_FAILURE',
  ENTITY_STATUS_LIST_CHANGED: 'ENTITY_STATUS_LIST_CHANGED',
  ENTITY_STATUS_LIST_PAGINATION: 'ENTITY_STATUS_LIST_PAGINATION',
  ENTITY_STATUS_LIST_CLEAR_PAGINATION: 'ENTITY_STATUS_LIST_CLEAR_PAGINATION',
};
